var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKm = function SvgKm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24 11.965H10.99c-2.583 2.583-4.144 4.577-5.739 6.172l6.783.61 10.525-1.043A11.946 11.946 0 0 0 24 12v-.035Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M5.253 6.226h17.269A11.997 11.997 0 0 0 12.001 0a11.96 11.96 0 0 0-8.468 3.498l1.72 2.728Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M5.773 17.704c-1.079 1.079-1.495 1.983-2.276 2.763A11.962 11.962 0 0 0 12 24c4.563 0 8.53-2.547 10.56-6.296H5.773Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M3.515 3.48c-4.687 4.687-4.687 12.285 0 16.971L12 11.966 3.515 3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M3.166 11.965a3.653 3.653 0 0 1 2.87-3.568 3.652 3.652 0 1 0 0 7.134 3.653 3.653 0 0 1-2.87-3.566Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m5.996 8.835.194.598h.629l-.509.37.194.597-.508-.37-.509.37.194-.598-.508-.37H5.8l.195-.597ZM5.996 10.4l.194.598h.629l-.509.37.194.597-.508-.37-.509.37.194-.598-.508-.37H5.8l.195-.597ZM5.996 11.965l.194.597h.629l-.509.37.194.598-.508-.37-.509.37.194-.598-.508-.37H5.8l.195-.597ZM5.996 13.53l.194.598h.629l-.509.369.194.598-.508-.37-.509.37.194-.598-.508-.37H5.8l.195-.597Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgKm;